import {del, post, put} from "../util/http.service";

export const createTag = rule => post("/tags", rule);

export const updateTag = (id, rule) => put("/tags/" + id, rule);

export const deleteTag = id => del("/tags/" + id);
